import api from '../../../App/socket';

export const getLeads = (params) => {
    const query = {
        api: 'db',
        model: 'Lead',
        action: 'Read',
        options: {
            /* limit: params.limit,
            offset: params.page * params.limit, */
            attributes: [
                'created_date',
                'valuations.valuation',
                'valuations.retail_price',
                'ref_lead_affiliate',
                'is_part_complete',
                'is_duplicate',
                'deleted_date',
                'approval.price.requires_approval',
                'approval.price.requires_approval_date',
                'approval.hpi_check.requires_approval',
                'approval.hpi_check.requires_approval_date',
            ],
            order: {
                _id: -1,
            },
            include: [
                {
                    model: 'Bike_lead',
                    path: 'ref_bike_lead',
                    attributes: ['mileage', 'vrm', 'unmaped_data.bike_model', 'unmaped_data.bike_cc', 'unmaped_data.bike_year'],
                    include: [
                        {
                            model: 'Bike_brand',
                            path: 'ref_bike_brand',
                            attributes: ['name'],
                        },
                        {
                            model: 'Bike_model',
                            path: 'ref_bike_model',
                            attributes: ['name', 'cc'],
                        },
                        {
                            model: 'Bike_variant',
                            path: 'ref_bike_variant',
                            attributes: ['year'],
                        },
                    ],
                },
                {
                    model: 'Lead_status',
                    path: 'ref_lead_status',
                    attributes: ['abbr', 'name'],
                },
                {
                    model: 'Lead_source',
                    path: 'ref_lead_source',
                    attributes: ['abbr', 'name'],
                },
                {
                    model: 'User',
                    path: 'ref_assigned_to',
                    attributes: ['person.first_name', 'person.last_name', 'person.photos.small'],
                },
                {
                    model: 'Lead_affiliate',
                    path: 'ref_lead_affiliate',
                    attributes: ['name'],
                },
            ],
            where: {
                ref_lead_status: {
                    // Customer Accepted, Price Given, IN Progress, Arrange Collection, Transport Arranged, Collection Confirmed
                    $in: ['5beac00ef25bf5f49685abfd', '5beabfe7f25bf5f49685abfc', '5bf2b498f83650911c3e3e80', '5c4837e08109b9f96e847a49', '5c8615197e203773e8886802', '5c87838c47f99d83281b350b', '5f8574e3d88a9007b68aa735', '5f85820bd88a9007b68aa739', '5f858198d88a9007b68aa738', '5f8574fcd88a9007b68aa736'],
                },
                deleted_date: { $exists: false },
                ref_lead_source: { $in: params.ref_lead_source },
                $or: [
                    { 'approval.price.requires_approval': true },
                    { 'approval.hpi_check.requires_approval': true },
                ],
            },
        },
    };

    return api
        .send(
            query,
        )
        .then(response => response)
        .catch(error => error);
};

export const getBikes = (reg, bikeBrand, bikeModel) => {
    if (reg) {
        reg = {
            $regex: reg,
            $options: 'i',
        };
    } else {
        reg = undefined;
    }

    return api.send({
        api: 'db',
        model: 'Bike_lead',
        action: 'Read',
        options: {
            attributes: ['_id'],
            where: {
                vrm: reg,
                ref_bike_brand: bikeBrand,
                ref_bike_model: bikeModel,
            },
        },
    });
};


export const getLeadsCount = (statusId, divisionId, agentId, affiliateId, dateFrom, dateTo, reg, bikeBrand, bikeModel, hideDuplicate, showDeleted) => {
    let created_date = {
        $gte: dateFrom,
        $lte: dateTo || dateFrom,
    };
    if (!created_date.$gte) {
        created_date = undefined;
    }


    if (reg || bikeBrand || (
        bikeBrand && bikeModel
    )) {
        return getBikes(reg, bikeBrand, bikeModel)
            .then(response => response.options.map(bike => bike._id))
            .then(data => countData(data))
            .catch(error => error);
    }

    return countData();


    function countData(leadsIdArray) {
        return api.send({
            api: 'db',
            model: 'Lead',
            action: 'Count',
            options: {
                where: {
                    ref_lead_status: statusId,
                    ref_lead_source: divisionId,
                    ref_assigned_to: agentId,
                    created_date,
                    ref_bike_lead: leadsIdArray,
                },
            },
        })
            .then(response => response.options.amount)
            .catch(error => error);
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_approval/requests/get_leads_request.js